import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mm-mcq"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "font-weight": "700"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "question"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "answer"
};
const _hoisted_8 = {
  style: {
    "display": "flex",
    "align-items": "self-start"
  }
};
const _hoisted_9 = {
  class: "menu"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_12 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.questionInfo.skill == 'S1' || $props.questionInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.questionInfo.itemName), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "question-text",
    innerHTML: $setup.itemText
  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].questionList, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "answer-item",
      key: 'que' + questionIndex
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(questionIndex + $props.questionInfo.menu), 1), _createElementVNode("p", {
      style: {
        "flex": "1"
      },
      class: "questionStem",
      innerHTML: questionItem.questionStem
    }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList[0].choiceList, (answerItem, answerIndex) => {
      return _openBlock(), _createBlock(_component_el_radio, {
        key: 'answer' + answerIndex,
        modelValue: $setup.answer[questionItem.questionId],
        "onUpdate:modelValue": $event => $setup.answer[questionItem.questionId] = $event,
        label: String.fromCharCode(65 + answerIndex),
        size: "large",
        onChange: $setup.setAnswer
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          innerHTML: answerItem.choiceText
        }, null, 8, _hoisted_12)]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "label", "onChange"]);
    }), 128)), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1))])]);
  }), 128))])])]);
}